import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { head, values } from 'lodash'

import { filters } from '../redux'

import DateRangePicker from '../components/DateRangePicker'

const DateRangeFilter = ({ name, value, dispatch }) => (
    <DateRangePicker
        value={ value }
        onChange={ (ranges) => {
            dispatch(filters.set(name, filters.TYPES.dateRange, head(values(ranges))))
        } }
    />
)

DateRangeFilter.propTypes = {
    name  : PropTypes.string,
    value : PropTypes.object
}

function mapStateToProps(state, ownProps) {
    const { name } = ownProps
    const value = filters.getValue(name, filters.TYPES.dateRange)(state)

    return {
        value
    }
}

export default connect(mapStateToProps)(DateRangeFilter)
